'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataRetriever', 'AVRO.UserManagement.Common'];
module.exports = angular.module('AVRO.UserManagement.AssignRole', dependencies).directive('rmAssignRole', require('./directives/AssignRoleDirective')).controller('AssignRoleController', require('./controllers/AssignRoleController'));